import React from "react";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { strings } from "../../../localization";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { ModalFullApplyDenied } from "../models";
import { closeModal } from "../reducers";
import { DeniedMessage } from "./DeniedMessage";

import styles from "./index.module.scss";

interface IProps {
    modalState: ModalFullApplyDenied;
}

export const FinancingFullDenied = (props: IProps): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const purchasePrice = useAppSelector(
        (state) => state.financing.purchasePrice,
    );
    const buttonText =
        (purchasePrice
            ? strings.get("FINANCING_RETURN_TO_CHECKOUT")
            : strings.get("FINANCING_RETURN_TO_SITE")) || "";

    const onClose = (e: React.MouseEvent<HTMLElement>): void => {
        e.preventDefault();
        dispatch(closeModal());
    };

    return (
        <div className={styles.wrapper}>
            {/* TODO(i18n): Remove <br /> tag from translation string - use jt to interpolate component: jt`We're Sorry.${<br />}Your application has been denied.` or split into separate elements with full sentences */}
            <h3
                className={styles.title}
                dangerouslySetInnerHTML={{
                    __html: t`We're Sorry.<br />Your application has been denied.`,
                }}
            ></h3>
            {props.modalState.result && (
                <DeniedMessage
                    backendType={props.modalState.result?.backend_type}
                    modalState={props.modalState}
                />
            )}
            <button
                className={concatClassNames(["button", styles.button])}
                onClick={onClose}
            >
                {buttonText}
            </button>
        </div>
    );
};
